import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ShoppingBag, Trash2 } from 'lucide-react';
import { useCart, useWishlist } from '../context/AppContext';

export default function Wishlist() {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const { wishlist, removeFromWishlist, clearWishlist } = useWishlist();

  if (wishlist.length === 0) {
    return (
      <div className="page-enter" style={{ textAlign: 'center', padding: '100px 24px' }}>
        <Heart size={56} color="var(--border)" style={{ marginBottom: 16 }} />

        <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 34, fontWeight: 300, marginBottom: 8 }}>
          Your wishlist is empty
        </h2>

        <p style={{ color: 'var(--text-light)', marginBottom: 28 }}>
          Save your favourite jewellery and find them here.
        </p>

        <button className="btn btn-primary btn-lg" onClick={() => navigate('/collections')}>
          Explore Collections
        </button>
      </div>
    );
  }

  return (
    <div className="page-enter" style={{ maxWidth: 1100, margin: '0 auto', padding: '48px 24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32, gap: 16 }}>
        <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 40, fontWeight: 300 }}>
          My Wishlist
        </h1>

        <button className="btn btn-outline" onClick={clearWishlist}>
          Clear All
        </button>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
          gap: 22,
        }}
      >
        {wishlist.map((item) => {
          const img = item.images?.[0]?.url || '/images/jewelry-placeholder.jpg';
          const price = item.discountPrice || item.price;

          return (
            <div
              key={item._id}
              style={{
                background: 'white',
                border: '1px solid var(--border)',
                borderRadius: 10,
                overflow: 'hidden',
              }}
            >
              <div
                onClick={() => navigate(`/product/${item.slug || item._id}`)}
                style={{
                  height: 230,
                  background: 'var(--cream)',
                  cursor: 'pointer',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={img}
                  alt={item.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>

              <div style={{ padding: 16 }}>
                <div
                  onClick={() => navigate(`/product/${item.slug || item._id}`)}
                  style={{
                    fontFamily: "'Cormorant Garamond',serif",
                    fontSize: 21,
                    fontWeight: 500,
                    cursor: 'pointer',
                    marginBottom: 8,
                  }}
                >
                  {item.name}
                </div>

                <div style={{ fontSize: 12, color: 'var(--text-light)', textTransform: 'capitalize', marginBottom: 10 }}>
                  {String(item.category || '').replaceAll('-', ' ')}
                </div>

                <div style={{ fontSize: 17, fontWeight: 600, color: 'var(--maroon)', marginBottom: 14 }}>
                  ₹{Number(price || 0).toLocaleString()}
                </div>

                <div style={{ display: 'flex', gap: 8 }}>
                  <button
  className="btn btn-primary"
  style={{ flex: 1 }}
  onClick={() => {
    addToCart(item);
    removeFromWishlist(item._id);
  }}
>
  <ShoppingBag size={15} />
  Add
</button>

                  <button
                    onClick={() => removeFromWishlist(item._id)}
                    style={{
                      width: 42,
                      border: '1px solid var(--border)',
                      background: 'white',
                      color: '#C62828',
                      cursor: 'pointer',
                      borderRadius: 4,
                    }}
                    title="Remove"
                  >
                    <Trash2 size={15} />
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}